var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "v-application" },
      [
        _vm._l(_vm.status, function(item, index) {
          return [
            index > 0
              ? _c("v-divider", {
                  style: {
                    "border-top-width": "10px !important",
                    "border-color": item.disabled
                      ? "var(--secondary) !important"
                      : "var(--" + item.color + ") !important",
                    "margin-top": "14px !important"
                  }
                })
              : _vm._e(),
            _c("LineItem", {
              attrs: {
                item: item,
                dados: _vm.estrutura,
                hideDescription: _vm.hideDescription
              },
              on: { goto: _vm.goTo }
            })
          ]
        })
      ],
      2
    ),
    _vm.loadingEstrutura
      ? _c(
          "div",
          [
            _c("v-progress-linear", {
              attrs: { rounded: "", indeterminate: "", color: "primary" }
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }